export default __webpack_public_path__ + "static/media/img_blog01.ac4b2c69.jpg";